import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { OrderDetail } from './order-detail';
import { SharedService } from './../../../../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class OrderDetailService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];
	
	orderDetails: any = [
		{ value: '31', name: 'Accommodation' },
		{ value: '4', name: 'Adjustment' },
		{ value: '37', name: 'Chair Top High Chair' },
		{ value: '34', name: 'Pak n Play' },
		{ value: '45', name: 'Option: Crib Bed Configuration' },
		{ value: '48', name: 'Option: Bunk Bed Configuration' },
		{ value: '14', name: 'Cancellation Fee' },
		{ value: '19', name: 'Cleaning Services' },
		{ value: '28', name: 'Concierge Services' },
		{ value: '38', name: 'Option: Couchbed linens requested' },
		{ value: '15', name: 'Damage Replacement' },
		{ value: '9', name: 'Damage Waiver - $3,000' },
		{ value: '2', name: 'Departure Housekeeping' },
		{ value: '43', name: 'Option: Double Bed Configuration' },
		{ value: '8', name: 'eCheck Discount' },
		{ value: '63', name: 'Firewood' },
		{ value: '21', name: 'Gift Basket' },
		{ value: '20', name: 'Grocery Service' },
		{ value: '60', name: 'Hot Tub' },
		{ value: '29', name: 'Housekeeping: Towel Service' },
		{ value: '52', name: 'Option: Inflatable' },
		{ value: '22', name: 'Ins - Damage $5000' },
		{ value: '7', name: 'Ins - Travel Prem' },
		{ value: '5', name: 'Ins - Travel Std' },
		{ value: '40', name: 'Option: King Bed Configuration' },
		{ value: '47', name: 'Option: King or Two Twins' },
		{ value: '10', name: 'Late Check-Out' },
		{ value: '50', name: 'Activities: Lei Greeting' },
		{ value: '16', name: 'Linens &amp; Cleaning (FREE)' },
		{ value: '18', name: 'Mid Stay Cleaning (FREE)' },
		{ value: '23', name: 'Mid Stay Cleaning' },
		{ value: '54', name: 'Option: Murphy' },
		{ value: '1', name: 'Nightly rate' },
		{ value: '17', name: 'Nightly Rate (FREE)' },
		{ value: '39', name: 'Option: Couchbed linens declined' },
		{ value: '13', name: 'Occupancy Fee' },
		{ value: '3', name: 'Pay-by-check' },
		{ value: '12', name: 'Pay-by-check Balance' },
		{ value: '11', name: 'Pay-by-check Deposit' },
		{ value: '59', name: 'Pet Fee' },
		{ value: '42', name: 'Option: Queen Bed Configuration' },
		{ value: '24', name: 'Rental Car (FREE)' },
		{ value: '27', name: 'Rental Car - Carseat' },
		{ value: '25', name: 'Rental Car Upgrade' },
		{ value: '30', name: 'Resort Fee' },
		{ value: '26', name: 'Roll Away Bed' },
		{ value: '66', name: 'Schedule Change' },
		{ value: '49', name: 'Option: Couchbed' },
		{ value: '53', name: 'Activities: Snorkel Delivery' },
		{ value: '56', name: 'Activities: Surf Board Rental' },
		{ value: '64', name: 'Travel Insurance - Decline' },
		{ value: '44', name: 'Option: Twin Bed Configuration' },
		{ value: '41', name: 'Option: Two Twin Beds Configuration' },
		{ value: '6', name: 'xResort Fee' },

	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'order-details';

	add(orderDetail: OrderDetail): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(orderDetail));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, orderDetail);
	}

	update(orderDetail: OrderDetail): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, orderDetail);
	}

	delete(developmentId: number, password?: string): Observable<ApiResponse> {
		let params = new HttpParams();
		if (password) {
			params = params.set('password', password);
		}
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`, { params });
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`);
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params });

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
	}

	//Find OpsNotes for Nightly rate from YieldMax Portal
	findNightlyRateFeesOpsNotesDetails(shortTermRentalId, numNights): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/properties/get-amount-added-to-rate-quote/${shortTermRentalId}/${numNights}`);
	}

	//Find OpsNotes for Nightly rate from YieldMax Portal
	findNightlyRateOpsNotesDetails(opsNoteRequest): Observable<ApiResponse> {
		const headerDict = {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'X-YIELDMAX-API-TOKEN': 'u3URF3HcTYFH4sj2kqELCeIzrLPg1t06F66IMLhLrfATQC2bVC',
		  }
		  
		  const requestOptions = {                                                                                                                                                                                 
			headers: new HttpHeaders(headerDict), 
		  };
		// return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/${checkInDate}/${checkOutDate}/${shortTermRentalId}`);
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/ops-notes`, opsNoteRequest, requestOptions);
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`);
	}

	deleteAllByReservationId(reservationId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/delete-invoice/${reservationId}`);
	}

	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
